export enum LocalStorageKeyEnum {
    ShowWelcomePopup = 'show-welcome-popup',
    CustomPortalName = 'custom-portal-name',
    ShowIpdSubmitConfirmation = 'show-ipd-submit-confirmation',
}
